<template>
	<div class="draggableDialog" v-show="show" :style="style">
		<!-- 注释掉的是拖拽事件 -->
    <div class="header">
			<div class="headerSlot">
				<slot name="header">
					title
				</slot>
			</div>
			<div class="headerBtns">
				<el-icon v-if="closable" class="headerBtn" @click="closeClick" name="close"  size="28"></el-icon>
			</div>
			<div style="clear: both"></div>
		</div>
		<transition name="fade">
			<div class="content" v-show="showContent">
					<slot name="content">
						content
					</slot>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		name: "DraggableDialog",
		props: {
			show: {
				default: true,
				type: Boolean
			},
			closable: {
				default: true,
				type: Boolean
			},
			width: {
				type: String,
				default: '400px'
			},
			height: {
				type: String,
				default: '600px'
			},
			top: {
				type: String,
				default: '50px'
			},
			left: {
				type: String,
				default: 'auto'
			},
			right: {
				type: String,
				default: 'auto'
			}
		},
		data() {
			return {
				showContent: true,
				expandIcon: 'arrow-up-fill',
			}
		},
		mounted() {

		},
		methods: {
			//拖拽事件
			mouseDown(e) {
				let sX = e.clientX;
				let sY = e.clientY;
				let sLeft = this.$el.offsetLeft;
				let sTop = this.$el.offsetTop;
				document.onmousemove = (e) => {
					let currentX = e.clientX;  //鼠标对于可视区域的x，y坐标
					let currentY = e.clientY;
					let left = sLeft + (currentX - sX)
					let top = sTop + (currentY - sY)
					let viewHeight = document.documentElement.clientHeight 
					let viewWidth = document.documentElement.clientWidth
					// 防止移出窗口外
					if(top < -20 || left < -this.$el.clientWidth + 10 || top > viewHeight - 10 || left > viewWidth - 10)
						return
					this.$el.style.left = left + 'px'   //this.$el指的是当前组件中的元素
					this.$el.style.top = top + "px"
				}
			},
			mouseUp() {
				document.onmousemove = null
			},
			//点击展开触发的方法
			expandClick() {
				this.showContent = !this.showContent     
				if (this.showContent) {
					this.expandIcon = 'arrow-up-fill'   //箭头icon的改变
				} else {
					this.expandIcon = 'arrow-down-fill'
				}
			},
			//点击关闭触发的方法
			closeClick() {
				this.$emit("update:show", false)
				this.$emit("dialog-close")
			}
		},
		computed: {
			style() {
				return {
					'max-height': this.height,
          width: this.width,
          top: this.top,
          left: this.left,
          right: this.right,
				}
			}
		},
		watch: {}
	}
</script>

<style lang="less" scoped>
	.fade-enter-active,     //折叠动画
	.fade-leave-active {
		transition: opacity .2s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active below version 2.1.8 */
		{
		opacity: 0;
	}


	.draggableDialog {
		position: absolute;
		width: 100%;
		z-index: 100;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

		.header {
			/deep/.u-iconfont::before {
				// font-size: 18px;
			}

			-webkit-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
			user-select: none;
			padding: 10px;
			background-color: #1da1f2;
			color: white;
			font-weight: bolder;
			// cursor: all-scroll;  //去掉的是十字选中效果

			.headerSlot {
				//float: left;
				height: 30px;
				line-height: 20px;
			}

			.headerBtns {
				float: right;

				.headerBtn {
					float: right;
					cursor: pointer;
					margin-left: 5px;
					height: 20px;
					line-height: 20px;
				}
			}
		}

		.content {
			padding: 10px;
			background-color: #fff;
			// height: 420px;
			// overflow-y: auto;
		}
	}
</style>
